module.exports = __webpack_public_path__ + "static/media/spices_video.cc6aadcf.png";